import { Text } from '@tonic-one/react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDashboardServicesStore } from 'src/models/useDashboardServicesModel';
import { generateRedirectUrlToLog } from 'src/pages/Log/shared';
import { getServiceNamesByValues } from 'src/utils/service';
import { formatTableTopX } from 'src/utils/table';

import { ThreatType } from '../../../../utils/enums';
import TableTemplate from '../../Charts/TableTemplate';
import DashboardCard from '../../Layout/DashboardCard';
import RedirectLink from '@Components/RedirectLink';
import { LogTypeEnum, SecurityFilterName } from '@Types/log';

function SecurityRiskTopUsers(props: { data: any; day: string }) {
  const { t } = useTranslation();
  const servicesModel = useDashboardServicesStore();

  const config = [
    { width: '50%', grow: 1, align: 'left', tooltip: true },
    { width: '30%', grow: 0, align: 'right' },
  ];
  const header = [
    t('dashboard.chart.column.user'),
    t('dashboard.chart.column.detections'),
  ];

  const data = formatTableTopX(
    props.data?.security_risk_scanTop5SenderSuspiciousURLs?.[props.day],
    ['key', 'doc_count'],
    t
  );
  const tableData = data.map((row) => [
    row[0],
    row[1] === 0 ? (
      0
    ) : (
      <RedirectLink
        href={`logs?${generateRedirectUrlToLog(
          [
            {
              field: 'threatType',
              values: [
                ThreatType.Phishing,
                ThreatType.MaliciousURL,
                ThreatType.Ransomware,
              ],
              type: 'terms',
            },
            {
              field: 'securityFilterName',
              values: [SecurityFilterName.WebReputation],
              type: 'terms',
            },
            {
              field: 'violator',
              values: [row[0] as string],
              type: 'terms',
            },
            {
              field: 'urlCategory',
              values: ['90'],
              type: 'mustNot',
              subType: 'terms',
            },
            {
              field: 'scanSource',
              values: getServiceNamesByValues(servicesModel.enabledServices),
              type: 'terms',
            },
          ],
          props.day,
          LogTypeEnum.DETECTION
        )}`}
      >
        <Text>{row[1]}</Text>
      </RedirectLink>
    ),
  ]);

  return (
    <DashboardCard title={t('dashboard.chart.title.atpTop5Users')}>
      <TableTemplate config={config} header={header} data={tableData} />
    </DashboardCard>
  );
}

export default React.memo(SecurityRiskTopUsers);
